import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import PlantCard from './PlantCard';
import omitButton from '../images/ui_buttons/omit_button.png';
import { useAppContext } from '../context/AppContext';


const IMAGE_URL = import.meta.env.VITE_S3_PNG_URL;

const PlantList = ({ plants, selectedPlantId, currentPlantCategory, onSelect }) => {
  const listContainerRef = useRef(null);
  const { state } = useAppContext();
  const { hasActiveSubscription, subscribedPlan } = state.user;

  useEffect(() => {
    const listContainer = listContainerRef.current;

    const handleWheel = (event) => {
      if (event.deltaY !== 0) {
        listContainer.scrollLeft += event.deltaY;
        event.preventDefault();
      }
    };

    listContainer.addEventListener('wheel', handleWheel, {
      passive: false,
    });

    return () => {
      listContainer.removeEventListener('wheel', handleWheel);
    };
  }, []);

  const handleOmitSelect = () => {
    onSelect(null, currentPlantCategory);
  };

  return (
    <div 
      className='plant-list-container' 
      ref={listContainerRef}
      style={{
        display: 'flex',
        flexDirection: 'row',
        gap: '15px',
        alignItems: 'center',
        backgroundColor: 'var(--median-window-color)',
        height: '200px',
        overflowX: 'auto',
        overflowY: 'hidden',
        whiteSpace: 'nowrap',
        padding: '10px',
        scrollbarWidth: 'thin',
        border: '7px solid white',
        borderRadius: '10px',
      }}
    >
      {/* "Omit" Plant Card */}
      <PlantCard
        plant={{ Common: 'Omit' }}
        image={omitButton}
        isSelected={selectedPlantId === null}
        onSelect={handleOmitSelect}
      />
      {/* Normal Plant Cards */}
      {plants.map((plant) => (
        <PlantCard
          key={plant.ID}
          plant={plant}
          subscribedPlan={subscribedPlan}
          image={`${IMAGE_URL}/${plant.ImageURL}.png`}
          isSelected={plant.ID === selectedPlantId}
          onSelect={() => onSelect(plant.ID, plant.Category)}
          shouldDisplayText={hasActiveSubscription}
        />
      ))}
    </div>
  );
};

PlantList.propTypes = {
  plants: PropTypes.arrayOf(
    PropTypes.shape({
      ID: PropTypes.string.isRequired,
      Common: PropTypes.string.isRequired,
      Category: PropTypes.string.isRequired,
      ImageURL: PropTypes.string.isRequired,
    })
  ).isRequired,
  selectedPlantId: PropTypes.string,
  currentPlantCategory: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default PlantList;
